module.exports = __webpack_public_path__ + "static/media/IconInstagram.51bb4d89.svg";